import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const getDisplayFirstName = (person) => {
    var _a, _b;
    const trimmedPreferred = (_a = person.preferredName) === null || _a === void 0 ? void 0 : _a.trim();
    if (person.displayPreferredNameEnabled && trimmedPreferred) {
        return trimmedPreferred;
    }
    if ((_b = person.displayFirstName) === null || _b === void 0 ? void 0 : _b.trim()) {
        return person.displayFirstName.trim();
    }
    // List APIs often bake preferred into fullName while leaving firstName legal
    // (e.g. fullName "Singh Banyal", firstName "Hitech"). Initials must follow
    // the name that is actually shown: preferred + last → SB, not HB.
    const fullName = (person.fullNameForHeadline || person.fullName || "").trim();
    const firstWord = fullName.split(/\s+/)[0] || "";
    const legalFirst = (person.firstName || "").trim();
    if (firstWord &&
        legalFirst &&
        firstWord.toLowerCase() !== legalFirst.toLowerCase()) {
        return firstWord;
    }
    return legalFirst || firstWord;
};
const Picture = (props) => {
    var _a;
    const displayName = props.person.fullNameForHeadline || props.person.fullName;
    if (props.url) {
        return (_jsx("img", { className: "av-profile-image rounded-circle", src: props.url, alt: displayName }));
    }
    return (_jsxs("div", { className: "av-profile-image rounded-circle d-flex justify-content-center flex-column", style: { backgroundColor: props.person.initialsBackgroundColorHex }, title: displayName, children: [getDisplayFirstName(props.person)[0] || "", ((_a = props.person.lastName) === null || _a === void 0 ? void 0 : _a[0]) || ""] }));
};
const ProfilePicture = (props) => {
    // set url to null if showProfilePicture is false, otherwise return photoUrl or smallPhotoUrl if photoUrl is undefined.
    const url = props.showProfilePicture
        ? props.photoUrl || props.person.smallPhotoUrl
        : null;
    if (props.profileUrl) {
        return (_jsx("a", { href: props.profileUrl, children: _jsx(Picture, { person: props.person, url: url }) }));
    }
    return _jsx(Picture, { person: props.person, url: url });
};
export default ProfilePicture;
